import React from "react";

const Construction = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 191.986 192" {...props}>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        y1="1"
        x2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d3e6f5" />
        <stop offset="1" stopColor="#f0f7fc" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        y1="0.5"
        x2="1"
        y2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#fe9661" />
        <stop offset="1" stopColor="#ffb369" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1="0.5"
        y1="1"
        x2="0.5"
        y2="0"
        href="#linear-gradient-2"
      />
      <linearGradient
        id="linear-gradient-4"
        y1="0.5"
        x2="1"
        y2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#54a5ff" />
        <stop offset="1" stopColor="#8ad3fe" />
      </linearGradient>
    </defs>
    <g id="Picto_Blank_Synthèse" transform="translate(-865.194 -286)">
      <g id="Brief_Design" data-name="Brief Design" transform="translate(861.194 282)">
        <path
          d="M161.28,4a20.6,20.6,0,0,0-20.628,20.57V189.13a6.555,6.555,0,0,1-6.154,6.857H16.16a6.555,6.555,0,0,1-6.154-6.857V171.988h92.828L10.006,101.879V24.57A20.6,20.6,0,0,1,30.634,4Z"
          transform="translate(14.35)"
          fill="url(#linear-gradient)"
        />
        <path
          d="M115.956,112.815H4V28L24.356,43.436Z"
          transform="translate(0 59.423)"
          fill="url(#linear-gradient-2)"
        />
        <path
          d="M10,63.677V40.03L40.737,63.677Z"
          transform="translate(14.356 87.675)"
          fill="#d7e9f7"
        />
        <path
          d="M74.356,31.18v82.1L67.2,127.123a3.393,3.393,0,0,1-6.039,0L54,113.281V31.18Z"
          transform="translate(121.63 67.031)"
          fill="url(#linear-gradient-3)"
        />
        <path
          d="M74.356,34.178V48.529H54V34.178a10.178,10.178,0,1,1,20.356,0Z"
          transform="translate(121.63 48.672)"
          fill="#eb7f58"
        />
        <path
          d="M88.711,24.356v6.785a6.785,6.785,0,0,1-6.785,6.785H48V24.356a20.356,20.356,0,1,1,40.711,0Z"
          transform="translate(107.275 0)"
          fill="#b4cde1"
        />
        <path
          d="M14.178,50.393a3.393,3.393,0,0,1-3.393,3.393H4V47h6.785A3.393,3.393,0,0,1,14.178,50.393Z"
          transform="translate(0 104.475)"
          fill="#eb7f58"
        />
        <path
          d="M14.178,46.393a3.393,3.393,0,0,1-3.393,3.393H4V43h6.785A3.393,3.393,0,0,1,14.178,46.393Z"
          transform="translate(0 94.756)"
          fill="#eb7f58"
        />
        <path
          d="M14.178,42.393a3.393,3.393,0,0,1-3.393,3.393H4V39h6.785A3.393,3.393,0,0,1,14.178,42.393Z"
          transform="translate(0 85.038)"
          fill="#eb7f58"
        />
        <path
          d="M14.178,38.393a3.393,3.393,0,0,1-3.393,3.393H4V35h6.785A3.393,3.393,0,0,1,14.178,38.393Z"
          transform="translate(0 75.319)"
          fill="#eb7f58"
        />
        <path
          d="M14.178,50.393a3.393,3.393,0,0,1-3.393,3.393H4V47h6.785A3.393,3.393,0,0,1,14.178,50.393Z"
          transform="translate(0 104.475)"
          fill="#eb7f58"
        />
        <path
          d="M14.178,46.393a3.393,3.393,0,0,1-3.393,3.393H4V43h6.785A3.393,3.393,0,0,1,14.178,46.393Z"
          transform="translate(0 94.756)"
          fill="#eb7f58"
        />
        <path
          d="M14.178,42.393a3.393,3.393,0,0,1-3.393,3.393H4V39h6.785A3.393,3.393,0,0,1,14.178,42.393Z"
          transform="translate(0 85.038)"
          fill="#eb7f58"
        />
        <path
          d="M14.178,38.393a3.393,3.393,0,0,1-3.393,3.393H4V35h6.785A3.393,3.393,0,0,1,14.178,38.393Z"
          transform="translate(0 75.319)"
          fill="#eb7f58"
        />
        <path
          d="M26.785,53.393v6.785H20V53.393a3.393,3.393,0,1,1,6.785,0Z"
          transform="translate(38.874 112.06)"
          fill="#eb7f58"
        />
        <path
          d="M30.785,53.393v6.785H24V53.393a3.393,3.393,0,1,1,6.785,0Z"
          transform="translate(48.593 112.06)"
          fill="#eb7f58"
        />
        <path
          d="M22.785,53.393v6.785H16V53.393a3.393,3.393,0,1,1,6.785,0Z"
          transform="translate(29.156 112.06)"
          fill="#eb7f58"
        />
        <path
          d="M18.785,53.393v6.785H12V53.393a3.393,3.393,0,1,1,6.785,0Z"
          transform="translate(19.141 112.06)"
          fill="#eb7f58"
        />
        <path
          d="M14.785,53.393v6.785H8V53.393a3.393,3.393,0,1,1,6.785,0Z"
          transform="translate(9.57 112.06)"
          fill="#eb7f58"
        />
        <path
          d="M57.711,38.356v47.5L17,65.5V18Z"
          transform="translate(31.695 34.274)"
          fill="url(#linear-gradient-4)"
        />
        <path
          d="M69.711,18V65.5L29,85.852v-47.5Z"
          transform="translate(60.952 34.274)"
          fill="url(#linear-gradient-4)"
        />
        <path
          d="M98.423,32.356,57.711,52.711,17,32.356,57.711,12Z"
          transform="translate(31.916 19.141)"
          fill="url(#linear-gradient-4)"
        />
      </g>
    </g>
  </svg>
);

export default Construction;
